var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"qrcodeComponent",staticClass:"qrcode-container"},[_c('img',{staticClass:"qrcode-img",attrs:{"src":_vm.src,"alt":"二维码"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }